import React, { useEffect, useState } from "react";
import VelkieLayout from "../VelkieLayout";
import { useTabIndicator } from "../../../component/useTabIndicator";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enUS } from "date-fns/locale";
import OutsideClickHandler from "react-outside-click-handler";
import moment from "moment";
import { apiGet } from "../../../Utils/apiFetch";
import apiPath from "../../../Utils/apiPath";
import { isEmpty, startCase } from "lodash";
const BettingHistoryVelkie = () => {
  const [tab, setTab] = useState("Exchange");
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([]);
  const [select, setSelect] = useState([]);
  const navigate = useNavigate();
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  const [pagination, setPagination] = useState({
    page: 0,
    totalPages: 0,
    hasPrevPage: false,
    hasNextPage: false,
  });
  const header = ["Exchange", "Bookmaker", "Fancybet", "Sportsbook", "Parlay"];
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    betType: "betfair",
    status: "completed",
    fromPeriod: previousDate,
    toPeriod: currentDate,
    page: 1,
    limit: 10,
  });
  let dummy = {
    Exchange: "betfair",
    Bookmaker: "bookmaker",
    Fancybet: "fancy",
    Sportsbook: "sportBook",
  };
  const getData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.getHistory, {
      ...filter,
      betType: dummy[tab],
    });
    if (status === 200) {
      if (response_users.success) {
        setData(response_users?.results?.data);
        setPagination({
          page: response_users?.results?.page,
          totalPages: response_users?.results?.totalPages,
          hasPrevPage: response_users?.results?.hasPrevPage,
          hasNextPage: response_users?.results?.hasNextPage,
        });
      } else {
        setPagination({
          page: 1,
          totalPages: 0,
          hasPrevPage: false,
          hasNextPage: false,
        });
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    getData();
  }, [tab]);
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  const ShowPrice = (res) => {
    if (isEmpty(res?.fancyName)) {
      if (
        (res?.teamSelectionWin == res?.selectionId && res?.betType == "back") ||
        (res?.teamSelectionWin != res?.selectionId && res?.betType == "lay")
      ) {
        return res?.profitAmount;
      } else {
        return -res?.loseAmount;
      }
    } else {
      if (res?.type == "No") {
        if (res?.decisionRun < res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      } else {
        if (res?.decisionRun >= res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      }
    }
  };

  return (
    <VelkieLayout>
      <div className="pb-20 relative" data-v-58b8c71f="">
        <div
          className="mb-20"
          data-v-732d8950=""
          style={{
            "--1344c9d1": `${indicatorStyle?.width || 57}px`,
            "--914528c2": `translateX(${indicatorStyle?.x || 7}px)`,
          }}
        >
          <header
            className="h-12 p-3 bg-secondary text-global-font-on-dark text-14 flex items-center justify-center"
            data-v-732d8950=""
          >
            Bets History
            <div
              onClick={() => navigate("/sports-velki")}
              className="icon-close text-16 absolute right-4"
            />
          </header>
          <section
            className="tab-wrapper relative bg-black-300 overflow-x-scroll"
            data-v-732d8950=""
          >
            <div
              className="h-full inline-block"
              data-v-732d8950=""
              style={{
                transform: "translateX(0px) translateY(0px) translateZ(1px)",
                transitionDuration: "0ms",
                transitionProperty: "transform",
                transitionTimingFunction: "cubic-bezier(0.165, 0.84, 0.44, 1)",
              }}
            >
              <ul
                ref={containerRef}
                className="ml-2 mr-1 w-full h-12 flex flex-nowrap justify-start items-center"
                data-v-732d8950=""
                style={{
                  pointerEvents: "auto",
                }}
              >
                {header?.map((res, index) => {
                  return (
                    <li
                      onClick={() => {
                        setTab(res);
                        setActiveIndex(index);
                      }}
                      className="text-13 font-bold py-2 mr-6 text-center whitespace-nowrap"
                      data-v-732d8950=""
                    >
                      {res}
                    </li>
                  );
                })}

                <motion.div
                  className="tab-indicator absolute left-0 bottom-1.5 bg-global-font-on-light rounded-full"
                  data-v-732d8950=""
                />
              </ul>
            </div>
          </section>
          <section data-v-3e750b5e className="bet-status relative">
            <div
              data-v-8a49f53f
              data-v-3e750b5e
              className="custom-select w-full p-2 relative bg-black-800"
              style={{ "--v821e4d10": "75px" }}
            >
              <button
                data-v-8a49f53f
                className="select text-left px-4 w-full h-30px border rounded border-reportForm-main bg-white bg-opacity-0 text-reportForm-main text-15"
                value="options"
              >
                <div
                  data-v-8a49f53f
                  className="relative flex justify-start items-center"
                >
                  <div
                    data-v-8a49f53f
                    className="option-container w-310px grid grid-cols-1 justify-start items-center leading-tight"
                    data-has-label="true"
                    data-has-alt="false"
                  >
                    <span data-v-8a49f53f className="mr-2">
                      Bet Status
                    </span>
                    <span
                      data-v-8a49f53f
                      className="option-context mr-2 font-bold truncate leading-tight"
                    >
                      Settled
                    </span>
                    {/**/}
                  </div>
                  <span
                    data-v-8a49f53f
                    className="icon-arrow-down absolute right-0 top-1.5 text-12 transition-transform origin-center duration-300"
                  />
                </div>
              </button>
              <div
                data-v-8a49f53f
                className="drop-down border border-reportForm-main rounded rounded-t-none border-t-0 bg-black-800 text-reportForm-main font-bold text-15 absolute z-10"
                style={{ display: "none" }}
              >
                <div data-v-8a49f53f className="options top-10 flex flex-col">
                  <p
                    data-v-8a49f53f
                    className="item h-30px flex items-center px-4 hover:bg-black-600"
                    value={2}
                    style={{ display: "none" }}
                  >
                    <span data-v-8a49f53f className="item-text relative">
                      Settled {/**/}
                    </span>
                  </p>
                  <p
                    data-v-8a49f53f
                    className="item h-30px flex items-center px-4 hover:bg-black-600"
                    value={3}
                  >
                    <span data-v-8a49f53f className="item-text relative">
                      Cancelled {/**/}
                    </span>
                  </p>
                  <p
                    data-v-8a49f53f
                    className="item h-30px flex items-center px-4 hover:bg-black-600"
                    value={4}
                  >
                    <span data-v-8a49f53f className="item-text relative">
                      Voided {/**/}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div
              data-v-3e750b5e
              className="w-full flex p-2 relative bg-black-800 text-button-normal"
            >
              <button
                onClick={() => setModal(true)}
                className="text-left px-2 h-30px border rounded border-reportForm-main bg-white bg-opacity-0 text-reportForm-main text-15 mr-2 flex-1 flex items-center justify-start"
              >
                <div className="icon-calendar mr-2" />
                <span className="text-white truncate">
                  {moment(filter?.fromPeriod).format("DD/MM/YYYY")} -{" "}
                  {moment(filter?.toPeriod).format("DD/MM/YYYY")}
                </span>
              </button>
              <button className="bg-button-normal p-2 px-4 rounded font-bold">
                Submit
              </button>
              <div>
                {modal && (
                  <OutsideClickHandler onOutsideClick={() => setModal(false)}>
                    {" "}
                    {/* <div className="fixed top-0 left-0 w-full h-full z-40 opacity-30" /> */}
                    <div className="fixed z-40 w-full container bottom-0 left-0">
                      <div className="bg-secondary flex flex-col p-1 pb-0 h-full overscroll-y-none rounded-t-xl shadow-top">
                        <header className="flex py-2">
                          <div className="main-filter flex-1 text-pop-title">
                            <ul className="main-filter-ul flex justify-center items-center leading-tight text-center">
                              <li className="main-filter-li relative mx-4 pb-1 font-bold">
                                Select Date
                              </li>
                            </ul>
                          </div>
                          <div
                            onClick={() => setModal(false)}
                            className="icon-close absolute right-2 flex justify-center items-center mr-2 cursor-pointer text-global-font-on-dark text-14"
                          />
                        </header>
                        <section className="date-picker-area rounded-t-lg bg-white flex justify-center">
                          <div
                            style={{ marginTop: "10px" }}
                            data-helptext="Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year"
                            className="vc-container vc-blue vc-is-expanded"
                          >
                            <div className="vc-popover-content-wrapper"></div>
                            <DateRange
                              editableDateInputs={true}
                              onChange={(item) => {
                                setFilter((prev) => {
                                  return {
                                    ...prev,
                                    fromPeriod: item?.selection?.startDate,
                                    toPeriod: item?.selection?.endDate,
                                  };
                                });
                              }}
                              moveRangeOnFirstSelection={false}
                              ranges={[
                                {
                                  startDate: new Date(filter?.fromPeriod),
                                  endDate: new Date(filter?.toPeriod),
                                  key: "selection",
                                },
                              ]}
                              locale={enUS}
                              maxDate={new Date()}
                            />
                            <div className="vc-popover-content-wrapper"></div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </OutsideClickHandler>
                )}
              </div>
            </div>
          </section>

          <div data-v-732d8950 className="content px-4 py-4">
            {data?.length > 0 ? (
              data?.map((res) => {
                return (
                  <div data-v-732d8950>
                    <section data-v-732d8950 className="mb-2">
                      <header className="bg-black-300 flex justify-center items-center rounded-t-8px">
                        <div className="py-2 px-4 text-center leading-5 break-all">
                          <span className="text-13">{obj[res?.eventType]}</span>
                          <i className="icon-triangle-black-600 inline-block align-baseline" />
                          <span className="text-13 font-bold">
                            {res?.matchName}
                          </span>
                          <i className="icon-triangle-black-600 inline-block align-baseline" />
                          <span className="text-13">
                            {" "}
                            {!isEmpty(res?.fancyName)
                              ? res?.fancyName
                              : tab == "Exchange"
                                ? "Match Odds"
                                : tab}
                          </span>
                        </div>
                      </header>
                      <section className="bg-white">
                        <div className="divide-y divide-black-300">
                          <div className="p-2 flex items-center">
                            <div
                              className={`shrink-0 w-50px h-8 back relative inline-block leading-loose mr-2 font-bold text-center bg-back rounded-full text-13 bg-${
                                res?.type == "No"
                                  ? "lay"
                                  : res?.type == "Yes"
                                    ? "back"
                                    : res?.betType
                              }`}
                            >
                              {startCase(res?.betType || res?.type)}
                            </div>
                            <span className="flex items-center text-13 font-bold min-h-28px leading-tight break-all">
                              {res?.teamName ||
                                res?.runnerName ||
                                res?.fancyName}
                            </span>
                          </div>
                          <div className="grid grid-cols-3 divide-x divide-black-300">
                            <div className="p-2 flex-1">
                              <div className="text-10">Odds req.</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {!isEmpty(res?.betType)
                                  ? res?.bhav
                                  : `${res?.betRun}/${res?.bhav}`}
                              </div>
                            </div>
                            <div className="p-2 flex-1">
                              <div className="text-10">Avg. Odds</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {!isEmpty(res?.betType)
                                  ? res?.bhav
                                  : `${res?.betRun}/${res?.bhav}`}
                              </div>
                            </div>
                            <div className="p-2 flex-1">
                              <div className="label text-10">Matched (PBU)</div>
                              <div className="font-bold leading-tight pt-0.5">
                                {res?.amount}
                              </div>
                            </div>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Bet ID</span>
                            <span className="pl-1 text-black-600">
                              {res?.matchBetId || res?.sessionBetId}
                            </span>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Bet Placed</span>
                            <span className="pl-1 text-black-600">
                              {moment(res?.timeInserted).format(
                                "YYYY-MM-DD HH:MM:SS",
                              )}
                            </span>
                          </div>
                          <div className="flex p-2 text-12">
                            <span className="w-1/3">Profit/Loss (PBU)</span>
                            <span
                              className={`pl-1 text-black-600 ${ShowPrice(res) > 0 ? "" : "text-error"}`}
                            >
                              {ShowPrice(res) > 0
                                ? ShowPrice(res)
                                : `(${Math.abs(ShowPrice(res))})`}
                            </span>
                          </div>
                        </div>
                      </section>
                      {select.includes(res?._id) && (
                        <section>
                          <div className="bg-black-200 divide-y divide-black-400">
                            <div className="row second flex border-b border-black-400 bg-black-400 p-2 text-12">
                              <span className="w-1/3">Bet Taken</span>
                              <span className="pl-1">
                                {moment(res?.timeInserted).format(
                                  "YYYY-MM-DD HH:MM:SS",
                                )}
                              </span>
                            </div>
                            <div className="grid grid-cols-3 divide-x divide-black-400">
                              <div className="p-2 flex-1">
                                <div className="text-10">Odds req.</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {!isEmpty(res?.betType)
                                    ? res?.bhav
                                    : `${res?.betRun}/${res?.bhav}`}
                                </div>
                              </div>
                              <div className="p-2 flex-1">
                                <div className="text-10">Odds Matched</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {!isEmpty(res?.betType)
                                    ? res?.bhav
                                    : `${res?.betRun}/${res?.bhav}`}
                                </div>
                              </div>
                              <div className="p-2 flex-1">
                                <div className="text-10">Stake (PBU)</div>
                                <div className="font-bold leading-tight pt-0.5">
                                  {res?.amount}
                                </div>
                              </div>
                            </div>

                            <div className="flex p-2 text-12">
                              <span className="w-1/3">Liability (PBU)</span>
                              <span className="pl-1 text-error">
                                ({res?.amount})
                              </span>
                            </div>

                            <div className="flex p-2 text-12">
                              <span className="w-1/3">Actual Odds</span>
                              <span className="pl-1">
                                {!isEmpty(res?.betType)
                                  ? res?.bhav
                                  : `${res?.betRun}/${res?.bhav}`}
                              </span>
                            </div>
                          </div>
                        </section>
                      )}
                      <footer
                        onClick={() => {
                          if (select.includes(res?._id)) {
                            setSelect((prev) => {
                              return prev?.filter((item) => {
                                return item != res?._id;
                              });
                            });
                          } else {
                            setSelect((prev) => {
                              return [...prev, res?._id];
                            });
                          }
                        }}
                      >
                        <div className="h-2 rounded-b-lg transition-colors duration-300 bg-black-400" />
                        <div className="h-4 rounded-b-lg w-90px mx-auto flex justify-center transition-colors duration-300 bg-black-400">
                          <span
                            className={`icon-arrow-down-sencodary relative -top-1 text-black transition-transform origin-center duration-300 transform ${select.includes(res?._id) ? "rotate-180" : ""}`}
                          />
                        </div>
                      </footer>
                    </section>
                  </div>
                );
              })
            ) : (
              <div
                data-v-732d8950
                className="flex justify-center items-center py-48"
              >
                <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                  <div
                    alt
                    className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                  />
                  <div>No Data</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </VelkieLayout>
  );
};

export default BettingHistoryVelkie;
